import { css, unsafeCSS } from 'lit-element';
import { border_box as borderBox } from '@aab/sc-styles-grid';
import { h4 } from '@aab/sc-styles-typography';
import {
  align_items_center, d_flex, text_center, text_left, d_inline_block, flex_row, flex_column, flex_column_reverse,
  rounded_left_2, rounded_right_2,
} from '@aab/sc-styles-utilities';
import {
  white, g300, gm55, gm75,
} from '@aab/sc-styles-colors';
import {
  pb_1, px_2, pl_2, spr_2, mb_0, mr_1, ml_1, ml_2,ml_3, ml_auto, smy__2, ml_0,
} from '@aab/sc-styles-spacing';

const styles = css`
    ${unsafeCSS(borderBox)}
    ${unsafeCSS(h4)}
    ${unsafeCSS(align_items_center)}
    ${unsafeCSS(d_flex)}
    ${unsafeCSS(pb_1)}
    ${unsafeCSS(pl_2)}
    ${unsafeCSS(spr_2)}
    ${unsafeCSS(mb_0)}
    ${unsafeCSS(ml_0)}
    ${unsafeCSS(mr_1)}
    ${unsafeCSS(ml_1)}
    ${unsafeCSS(ml_2)}
    ${unsafeCSS(ml_3)}
    ${unsafeCSS(ml_auto)}
    ${unsafeCSS(text_center)}
    ${unsafeCSS(text_left)}
    ${unsafeCSS(d_inline_block)}
    ${unsafeCSS(flex_row)}
    ${unsafeCSS(flex_column_reverse)}
    ${unsafeCSS(flex_column)}
    ${unsafeCSS(smy__2)}
    ${unsafeCSS(rounded_left_2)}
    ${unsafeCSS(rounded_right_2)}
    ${unsafeCSS(px_2)}
    
    .pagination-container {
      height: 72px;
      font-size: 14px;
    }

    .bg-white-me {
    background: ${unsafeCSS(white)};
    }
    .pagination-left-pane {
      width: 35%;
      color:#333;
      font-weight:400;
    }

    .pagination-right-pane {
      color:#333;
      width:65%;
      font-weight:400;
      flex-grow:2
    }

    .pagination-button {
      background:${unsafeCSS(gm55)};
      border: 1px solid ${unsafeCSS(gm75)};
      width: 56px;
      height: 40px;
      padding:8px 16px;
    }

    .pagination-button:hover {
      border: 1px solid  ${unsafeCSS(g300)};
      cursor:pointer;
    }

    .pagination-button:active {
      border: 1px solid  ${unsafeCSS(g300)};
      background: ${unsafeCSS(gm75)}
      cursor:pointer;
    }
    
    .dropdown-width {
      width: 90px;
    }
    .input-component-width {
      width: 60px;
    }
    .page-button-container {
      width: max-content;
    }

`;

export default styles;
